import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { bsc, mainnet, polygon } from '@reown/appkit/networks'
import { QueryClient } from '@tanstack/react-query'
import { getChainWithCustomRpcUrls } from './utils'

// Get projectId from environment
const projectId = import.meta.env.VITE_APP_WC_PROJECT_ID || ''

// Create a query client
export const queryClient = new QueryClient()

// Define metadata for the application
const metadata = {
  name: 'Nomiswap',
  description: 'Nomiswap DEX',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://nomiswap.io',
  icons: ['https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/bsc.png'],
}

// Configure networks with custom RPC URLs - Only BSC, Ethereum, and Polygon
const networks: [any, ...any[]] = [
  getChainWithCustomRpcUrls(bsc),
  getChainWithCustomRpcUrls(mainnet),
  getChainWithCustomRpcUrls(polygon),
]

// Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
})

// Create AppKit instance
export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-font-family': 'Inter, sans-serif',
    '--w3m-accent': '#00a0ff',
  },
  chainImages: {
    1: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/ethereum.png',
    56: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/bsc.png',
    137: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/matic.png',
  },
  features: {
    analytics: true,
  },
  // Exclude specific wallets if needed
  featuredWalletIds: [],
  excludeWalletIds: ['19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927'],
})

// Export wagmi config for use in hooks
export const { wagmiConfig } = wagmiAdapter
export const CHAINS = networks
